export default {"src":"/_next/static/media/Company6.82776fb8.svg","height":60,"width":120,"blurWidth":0,"blurHeight":0};